export default {
	USD: "$",
	KRW: "₩",
	JPY: "¥",
	GBP: "£",
	EUR: "€",
};
